// Components==============
import {
    faAlignLeft,
    faBook,
    faBriefcase,
    faCalendar,
    faCalendarDay,
    faClock,
    faEnvelope,
    faGlobeEurope,
    faMapMarkerAlt,
    faMoneyBill,
    faPhone,
    faUser,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/UI/Button';
import Modal from 'components/UI/Modal';
import RichText from 'components/UI/RichText';
import React from 'react';
import { getLink } from 'utilities/getLink';
import { getVacancyShorthand } from 'utilities/getVacancyShorthand';
import './VacancyModal.module.scss';
import { getAvailabilityShorthand } from 'utilities/getAvailabilityShorthand';
import { getEmploymentShorthand } from 'utilities/getEmploymentShorthand';
// =========================

const formatDate = (isoString) => {
    const date = new Date(isoString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
};

export default function VacancyModal({ vacancy, color }) {
    if (!vacancy) return <></>;
    const labels = [
        {
            name: 'Functie',
            icon: faUser,
            value: getVacancyShorthand(vacancy.type),
        },
        {
            name: 'Beschikbaarheid',
            icon: faClock,
            value: getAvailabilityShorthand(vacancy.beschikbaarheid),
        },
        {
            name: 'Dienstverband',
            icon: faBriefcase,
            value: getEmploymentShorthand(vacancy.dienstverband),
        },
        {
            name: 'Locatie',
            icon: faMapMarkerAlt,
            value: vacancy.locatie,
        },
        {
            name: 'Sector',
            icon: faBook,
            value: vacancy.sector,
        },
        {
            name: 'Ingangs datum',
            icon: faCalendarDay,
            value: vacancy.ingangsdatum,
        },
        {
            name: 'Salaris',
            icon: faMoneyBill,
            value: vacancy.salaris,
        },
        {
            name: 'Upload datum',
            icon: faCalendar,
            value: formatDate(vacancy.created_at),
        },
        {
            name: 'Website',
            icon: faGlobeEurope,
            value: vacancy?.school?.contact?.website,
        },
    ];

    return (
        <Modal slug={`vacancy-popup/${vacancy?.id}`} color={color.hex}>
            <div styleName="content">
                <div styleName="top">
                    <div styleName="left">
                        <h3 style={{ color: color.hex }}>{vacancy.name}</h3>
                        <p style={{ color: color.hex }}>
                            {vacancy.school?.name}
                        </p>
                    </div>
                    {vacancy?.school?.logo && (
                        <img
                            src={vacancy.school?.logo}
                            alt={vacancy.school?.name}
                        />
                    )}
                </div>
                <div styleName="labels">
                    {labels.map((label) =>
                        label.value === null ? null : (
                            <div styleName="label" key={label.name}>
                                <p styleName="title">
                                    {label.name}{' '}
                                    <FontAwesomeIcon icon={label.icon} />
                                </p>
                                {label.name === 'Website' ? (
                                    <a
                                        href={label.value}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {label.value?.replace(
                                            /(^\w+:|^)\/\//,
                                            ''
                                        )}
                                    </a>
                                ) : (
                                    <p>{label.value}</p>
                                )}
                            </div>
                        )
                    )}
                </div>
                <div styleName="button-wrapper">
                    {!!vacancy?.button?.phone && (
                        <a href={`tel:${vacancy?.button?.phone}`}>
                            <Button color={color.name}>
                                Neem contact op{' '}
                                <FontAwesomeIcon icon={faPhone} />
                            </Button>
                        </a>
                    )}
                    {!!vacancy?.button?.link && (
                        <a
                            href={getLink(vacancy?.button?.link)}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <Button color={color.name}>
                                Naar sollicitatie formulier{' '}
                                <FontAwesomeIcon icon={faAlignLeft} />
                            </Button>
                        </a>
                    )}
                    {!!vacancy?.button?.email && (
                        <a href={`mailto:${vacancy?.button?.email}`}>
                            <Button color={color.name}>
                                Stuur een mail{' '}
                                <FontAwesomeIcon icon={faEnvelope} />
                            </Button>
                        </a>
                    )}
                </div>
                <div styleName="divider" style={{ background: color.hex }} />
                <div styleName="bottom">
                    <RichText
                        richText={[
                            {
                                layout: 'text',
                                attributes: {
                                    text: vacancy.description,
                                },
                            },
                        ]}
                    />
                </div>
            </div>
        </Modal>
    );
}
